"use client";
import { jsx as p } from "react/jsx-runtime";
import { createContext as m, useState as e, useContext as P } from "react";
const s = m({
  setIsOpen: () => {
  },
  isOpen: !1,
  slug: null,
  setSlug: () => {
  },
  useCase: null,
  setUseCase: () => {
  },
  primaryProduct: null,
  setPrimaryProduct: () => {
  }
}), d = ({ children: t }) => {
  const [l, n] = e(!1), [r, o] = e(null), [u, a] = e(null), [c, i] = e(null);
  return /* @__PURE__ */ p(s.Provider, { value: {
    isOpen: l,
    setIsOpen: n,
    slug: r,
    setSlug: o,
    useCase: u,
    setUseCase: a,
    primaryProduct: c,
    setPrimaryProduct: i
  }, children: t });
}, f = () => P(s);
export {
  d as TemplateDetailProvider,
  f as useTemplateDetail
};
//# sourceMappingURL=TemplateDetailContext.es.js.map
